"use client";
import Script from "next/script";
import { usePathname } from "next/navigation";
import { isNoTrackingRoute } from "@/constants/noTrackingRoutes";
import { getGoogleMapsRegion } from "@/lib/envConfig";

export default function MapsScript() {
  const pathname = usePathname();
  const apiKey = process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY;
  const region = getGoogleMapsRegion();
  const blockTracking = isNoTrackingRoute(pathname);

  if (blockTracking) return null;

  return (
    <Script
      id="gmaps-js"
      strategy="beforeInteractive"
      src={`https://maps.googleapis.com/maps/api/js?key=${apiKey}&language=de&region=${region}&v=weekly`}
      onLoad={() => {
        // eslint-disable-next-line no-undef
        console.log("[maps script] loaded", !!google?.maps);
      }}
      onError={(e) => console.error("[maps script] failed", e)}
    />
  );
}
